import { render, staticRenderFns } from "./CompletedOrders.vue?vue&type=template&id=4577de4c&scoped=true"
import script from "./CompletedOrders.vue?vue&type=script&lang=js"
export * from "./CompletedOrders.vue?vue&type=script&lang=js"
import style0 from "./CompletedOrders.vue?vue&type=style&index=0&id=4577de4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577de4c",
  null
  
)

export default component.exports